import { Component } from '@angular/core';
import { FieldWrapper } from "@ngx-formly/core";

@Component({
  selector: 'app-membership-section',
  templateUrl: './membership-section.component.html',
  styleUrls: ['./membership-section.component.scss']
})
export class MembershipSectionComponent extends FieldWrapper {

}
